import { ACHProcessorData as ach } from "globalConstants";

export class ACHProcessorValues {
	monthlyVolumeAch = "";
	monthlyVolumeAchPayouts = "";
	highTicketAch = "";
	highTicketAchPayouts = "";
	ticketCountAch = "";
	ticketCountAchPayouts = "";
	customerType = ach.CustomerType.Individuals.value;
	paymentAuthorizationType =
		ach.PaymentAuthorizationType.SignedContract.value;
	statementDescriptor = "";
	useOfPaymentServiceDescription = "";
	isApplyBankAccountData = ach.IsApplyBankAccountData.Yes.value;
	billingRouting = "";
	billingBank = "";
	billingAccount = "";
	billingAccountName = "";
}
